import React from 'react'
import { ChatbotStepActionData, saveVariableToVariableActionData } from '../../../../models/flowBuilderTypes'
import { useFlowBuilderStore } from '../../../../store/flowBuilderStore'
import formStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import { getVariableToVariableValueText } from '../flowBuilderConstants'

const VariableToVariableNode = ({ id, data }: { id: string, data: ChatbotStepActionData<saveVariableToVariableActionData> }) => {
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    return (
        <>  
            <div>
                <span className={formStyles.dataSavedTextStyle}>
                    {`Variable Assignment`}
                </span>
                <span className={formStyles.dataSavedValueStyle}>
                    {getVariableToVariableValueText(customVariableList, data?.action_data?.chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id, data?.action_data?.source_chatbot_custom_variable_configuration?.chatbot_custom_variable_configuration_id, data?.action_data?.variable_static_value, "node")}
                </span>
            </div>
        </>
    )
}

export default VariableToVariableNode
